import { useNavigate } from "react-router-dom";

export const useReturnBackNavigation = (url: string) => {
  const navigate = useNavigate();

  const handleReturn = () => {
    const referrer = document.referrer;
    const currentOrigin = window.location.origin;

    if (referrer && referrer.startsWith(currentOrigin)) {
      navigate(url);
    } else {
      navigate(-1);
    }
  };

  return { handleReturn };
};
